module.exports = __webpack_public_path__ + "img/background-01.f23566fe.svg";